import React from "react"

const Footer = () => {
  return (
    <>
      <footer>
        <div className='conatiner text-center'>
          <p>© Copyright 2023</p>
        </div>
      </footer>
    </>
  )
}

export default Footer
